import React from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import { Alert, AlertTitle, ButtonProps, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.getContrastText('#D32F2F'),
  backgroundColor: '#D32F2F',
  borderColor: '#D32F2F',
  minWidth: '232px',
  height: '56px',
  borderRadius: '12px',
  fontSize: '18px',
  '&:hover': {
    backgroundColor: '#D32F2F',
    borderColor: '#D32F2F',
  },
}))

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const { t } = useTranslation()
  return (
    <>
      <Alert variant="outlined" severity="error">
        <AlertTitle>{t(`error.unspecific`)}</AlertTitle>
        <ColorButton
          onClick={resetErrorBoundary}
          variant="outlined"
          sx={{
            textTransform: 'none',
            bgcolor: 'white',
            color: 'white',
            borderColor: 'white',
          }}
        >
          {t(`error.try`)}
        </ColorButton>
      </Alert>
    </>
  )
}

interface Props {
  children: React.ReactNode
}
function GeneralBoundary(props: Props) {
  const { children } = props
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
  )
}

export default GeneralBoundary
